import React, { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Stack } from '@mui/material';
import { MarketplaceHomePageLink } from '../MarketplaceHomePageLink';

interface GuestAuthLayoutProps {
  children?: ReactNode;
}

export const GuestAuthLayout: FC<GuestAuthLayoutProps> = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#FFFFFF',
        py: 4,
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 16,
          left: 24,
        }}
      >
        <MarketplaceHomePageLink />
      </Box>
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            bgcolor: 'white',
          }}
        >
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
};
